<template>
  <div class="ask-container" :class="{ 'disabled': disabled }">
    <div class="ask-wrapper">
      <div class="textarea-wrapper">
        <textarea
        ref="textarea"
        rows="1"
        v-model="question"
        :placeholder="limitReached ? $t('mine.chat.limitPlaceHolder') : $t('mine.chat.askPlaceholder')"
        @input="handleResizeTextArea"
        @keypress="handlePress"
        />
        </div>
        <div class="button-wrapper">
        <button
          :class="['send-button', { loading: isLoading || isAnswering }]"
          @click="handleSubmit"
        >
          <div v-if="isLoading || isAnswering" class="droplet_spinner">
            <div class="droplet"></div>
            <div class="droplet"></div>
            <div class="droplet"></div>
          </div>
          <i v-else class="icon icon--send-white" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AskContainer',
  props: {
    isLoading: Boolean,
    isAnswering: Boolean,
    limitReached: Boolean,
    disabled: Boolean
  },

  data () {
    return {
      question: '',
      textarea: null
    }
  },
  computed: {
    isDisabled () {
      return this.checkIsEmpty() || this.disabled
    }
  },
  methods: {
    handleSubmit () {
      if (this.isDisabled) return

      this.$emit('submit', { prompt: this.question })
      this.question = ''
      this.$refs.textarea.blur()
    },

    handleResizeTextArea () {
      if (this.$refs.textarea.scrollHeight > 108) return
      this.$refs.textarea.style.height = 'auto'
      this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + 'px'
    },

    handlePress (e) {
      if (e.keyCode !== 13) return
      if (e.shiftKey) return

      this.$refs.textarea.style.height = 'auto'
      e.preventDefault()
      this.handleSubmit()
    },

    checkIsEmpty () {
      return this.question.length === 0
    }
  }
}
</script>

<style lang="scss" scoped>
.ask-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 11px 13px 13px;
  background-color: #ECECEC;
  box-sizing: border-box;

  &.disabled {
    pointer-events: none;
    .send-button {
      background-color: #999;
    }
  }
  .ask-wrapper {
    display: flex;
    align-items: flex-end;
    width: 100%;
    background-color: #111111;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px 0px #0000001f;

    .textarea-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 20px 20px 18px 20px;

      textarea {
        min-height: 20px;
        width: 100%;
        padding: 0;
        border: none;
        background: none;

        font-size: 18px;
        line-height: 1.2;
        text-align: left;
        outline: none;
        resize: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        color: #FFFFFF;

        &::placeholder {
          color: #BFBFBF;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }

  .button-wrapper {
    padding: 11px 11px 11px 0;
  }

  .send-button {
    @include flexXYcenter;
    width: 34px;
    height: 34px;
    padding: 2px;
    border-radius: 4px;
    background-color: $brandColor;
    &.loading {
      background-color: transparent;
    }
    .droplet_spinner {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      .droplet {
        width: 6px;
        height: 6px;
        background-color: $brandColor;
        border-radius: 50%;
        transform-origin: center bottom;
        animation: bounce 1.2s cubic-bezier(0.3, 0.01, 0.4, 1) infinite;

        &:nth-child(1) {
          animation-delay: -0.4s;
        }
        &:nth-child(2) {
          animation-delay: -0.2s;
        }
        &:nth-child(3) {
          animation-delay: 0s;
        }
      }

      @keyframes bounce {
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      }
    }

  }

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 12px;
    background: linear-gradient(180deg, rgba(236, 236, 236, 0) 0%, #ECECEC 100%);
    transform: translateY(-100%);
  }
}
@media (max-width: 768px) {
  .ask-wrapper {
    .textarea-wrapper {
      textarea {
        font-size: 13px;
      }
    }
  }
}
</style>
